import {PROJECT_TAGS} from '@/constants';
import {PaymentLinkFlows} from '@/dataSource/src/api/payment-link/constants';
import {
  IBankingEventDataDefinition,
  IEventBaseDataSchema,
  IRequestDataDefinition,
} from '@/services';

import {IPaymentLinkInformation} from '../entities';

export const buildPaymentLinkTrackingPayload = (
  response: IPaymentLinkInformation,
): IEventBaseDataSchema => {
  const banking: IBankingEventDataDefinition = {
    payment_link: {
      flow: response.single_payment
        ? PaymentLinkFlows.LINK
        : PaymentLinkFlows.QR,
      payment_method: '',
    },
    receiver: {
      user: {
        id: response?.receiver_user?.id ?? '',
      },
    },
    transaction: {
      amount: response?.amount?.toString() ?? '',
    },
  };

  const request: IRequestDataDefinition = {
    payment_link: {
      id: response?.id ?? '',
    },
    description: Boolean(response?.information?.note),
    gif: Boolean(response?.information?.gif),
    flow: response?.single_payment
      ? PaymentLinkFlows.LINK
      : PaymentLinkFlows.QR,
  };

  return {
    project_tag: PROJECT_TAGS.PAYMENT_LINK,
    ...(banking.receiver?.user?.id && {
      user: {id: banking.receiver?.user?.id},
    }),
    Fintech: banking,
    Banking: banking,
    Request: request,
  };
};
